<template>
    <div
        v-if="showInfomation"
        class="information-modal"
        @click.stop="1"
        ref="informationModal"
    >
        <div class="info-bg"></div>
        <div
            class="info-content scrollbar"
            ref="infoContent"
            v-html="notes"
        ></div>
        <v-btn @click="close_information" class="close-info-btn">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </div>
</template>

<script>
import { timeout } from "@/utils/util.js";
export default {
    name: "information-modal",
    props: {
        notes: {
            type: String,
            default: () => {
                return "";
            },
        },
    },
    data() {
        return {
            showInfomation: false,
        };
    },
    mounted() {
        $(document).on("click", () => this.close_information());
        $("button.v-btn").on("click", () => this.close_information());
    },
    methods: {
        //  开启卡片信息弹框
        async open_information() {
            this.showInfomation = false;
            await timeout(30);
            this.showInfomation = true;
            await timeout(30);
            this.normal_vision();

            $(this.$refs.informationModal)
                .addClass("open")
                .removeClass("close");
        },
        //  关闭卡片信息弹框
        async close_information() {
            $(this.$refs.informationModal)
                .addClass("close")
                .removeClass("open");
            await timeout(400);
            this.showInfomation = false;
        },

        // 显示处理
        normal_vision() {
            //  重新计算高度
            this.$refs.informationModal.style.height =
                this.$refs.infoContent.scrollHeight + "px";

            // 边缘判断
            if (
                $(this.$refs.informationModal).offset().left +
                    $(this.$refs.informationModal).width() >=
                window.innerWidth
            ) {
                $(this.$refs.informationModal).css({
                    left: "auto",
                    right: "20px",
                });
            }
        },
    },
    components: {},
};
</script>

<style lang="scss">
.information-modal {
    width: 320px;
    max-width: 320px;
    height: 50px;
    position: absolute;
    z-index: 666;
    top: 46px;
    left: calc(100% - 80px);
    .info-content,
    .info-bg {
        width: 100%;
    }

    &.open {
        .info-bg {
            height: 100%;
            opacity: 1;
            transition: all 0.35s cubic-bezier(0.65, 0.55, 0.265, 1.2);
        }

        .info-content {
            opacity: 1;
            transform: translateY(0);
            transition: all 0.25s ease-out 0.2s;
            overflow-y: auto;
            height: 100%;
        }

        .close-info-btn {
            opacity: 1;
        }
    }

    &.close {
        .info-bg {
            height: 0;
            opacity: 0;
            transition: height 0.25s cubic-bezier(0.68, -0.55, 0.265, 1.55) 0.1s,
                opacity 0.6s ease 0.2s;
        }

        .info-content {
            opacity: 0;
            transform: translateY(20px);
            transition: all 0.13s ease-in;
        }

        .close-info-btn {
            opacity: 0;
        }
    }

    .info-bg {
        height: 0;
        opacity: 0;
        background-color: #fff;
        box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%),
            0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%);
        border-radius: 4px;
    }

    .info-content {
        width: 100%;
        padding: 20px 16px 24px 16px;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        font-size: 14px;
        word-break: break-all;
        opacity: 0;
        transform: translateY(20px);
        box-sizing: border-box;

        * {
            font-size: 14px;
            word-break: break-all;
        }

        p {
            margin-bottom: 4px;

            &:nth-of-type(1) {
                strong {
                    margin-top: 0;
                }
            }

            strong {
                display: block;
                margin-bottom: 8px;
                margin-top: 20px;
            }
        }

        a {
            text-decoration: underline;
        }
    }

    button {
        position: absolute;
        top: 8px;
        right: 8px;

        i {
            font-size: 20px !important;
        }
    }

    .close-info-btn {
        border-radius: 50%;
        padding: 2px;
        overflow: hidden;
        opacity: 0;
        transition: all 0.25s ease;
    }
}

.user-new-believer {
    .information-modal {
        &.open {
            .info-content {
                overflow-y: auto;
                height: 100%;
            }
        }
        .close-info-btn {
            top: 6px;
            right: 6px;
        }
    }
}

.user-new-believer {
    .information-modal .info-content * {
        word-break: normal;
    }
}
</style>
